import './styles/Avatar.css';

interface AvatarProps {
  src?: string;
  fallback?: string;
  size?: 'sm' | 'md' | 'lg';
}

const Avatar: React.FC<AvatarProps> = ({ src, fallback, size = 'md' }) => (
  <div className={`avatar avatar--${size}`}>
    {src ? (
      <img src={src} alt="avatar" className="avatar__img" />
    ) : (
      <span className="avatar__fallback">{fallback || '?'}</span>
    )}
  </div>
);

export default Avatar;
